// extracted by mini-css-extract-plugin
module.exports = {"root":"page_root__ql9YX","main":"page_main__HA9zO","marquee":"page_marquee__aqOMk"};